import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  subscription ChatDeleted($id: ID!) {
    chatDeleted(id: $id)
  }
`);
